import './styles.css';

interface CloseButtonProps {
    onClick: () => void;
}

export function CloseButton({ onClick }: CloseButtonProps): JSX.Element {
    return (
        <span className="close-button" onClick={onClick}>
            &#10006;
        </span>
    );
}
